module.exports = __webpack_public_path__ + "AM-verified-buyer-logo.2073c344.png";